import { Injectable } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { AcceptTermsDialogPage } from '@app/pages/accept-terms-dialog/accept-terms-dialog.page';
import { NavModalBaseComponent } from '@app/shared/components/nav-modal-base/nav-modal-base.component';
import { environment } from '@env';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil, filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TermsModalService {

  modalStatus$ = new BehaviorSubject<'OPEN' | 'DISMISSED' | 'NOT_CREATED'>('NOT_CREATED');
  
  private onDestroy = new Subject();

  constructor(
    private router: Router,
    private modalController: ModalController,
  ) { }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.modalStatus$.complete();
  }

  activateTermsModal() {
    this.router.events.pipe(
      takeUntil(this.onDestroy),
      filter((e: RouterEvent) => e instanceof NavigationEnd),
      take(1)
    ).subscribe((e: RouterEvent) => {
      if (
        environment.showTerms &&
        !(
          e.url.startsWith("/klarna-checkout") ||
          e.url.startsWith("/klarna-confirmation") ||
          e.url.startsWith("/svea-checkout") ||
          e.url.startsWith("/svea-confirmation")
        )
      ) {
        this.openTermsModal();
      }
    });
  }

  async openTermsModal() {
    const modal = await this.modalController.create({
      component: NavModalBaseComponent,
      componentProps: {
        rootPage: AcceptTermsDialogPage
      },
      keyboardClose: true,
      backdropDismiss: false
    });

    await modal.present();
    this.modalStatus$.next('OPEN');

    modal.onDidDismiss().then(() => this.modalStatus$.next('DISMISSED'));
  }
}
